module.exports = __webpack_public_path__ + "img/bologna-logo-icon.24f7f2cd.png";